import { IndependentAuth } from "./independent";

export const AUTH_ROUTES = [
  { path: "/", element: IndependentAuth },
];
